import { gql, useQuery } from "@apollo/client";
import { ErrorComponent } from "@src/components";
import Summary from "@src/components/summary/Summary";
import { type GQLSimsSummaryDashboardAdminQuery, type GQLSimsSummaryDashboardAdminQueryVariables } from "@src/graphql.generated";
import CameraActive from "@src/icons/CameraActive";
import SimPerUser from "@src/icons/SimPerUser";
import { type FC, type PropsWithChildren } from "react";
import { FormattedMessage, useIntl } from "react-intl";

const simsSummaryDashboardAdminQuery = gql`
    query SimsSummaryDashboardAdmin {
        cameraSummaryDashboardAdmin {
            activeSimsCount
            activatedCamerasCount
            simsPerUserCount
        }
    }
`;

const SimCardsSummary: FC<PropsWithChildren> = () => {
    const { data, error } = useQuery<GQLSimsSummaryDashboardAdminQuery, GQLSimsSummaryDashboardAdminQueryVariables>(simsSummaryDashboardAdminQuery);
    const intl = useIntl();

    const summaryItems = [
        {
            count: data?.cameraSummaryDashboardAdmin.activeSimsCount,
            text: <FormattedMessage id="reviermanager.page.devices.summary.sim" defaultMessage="Aktive Kameras" />,
            icon: <CameraActive fontSize="large" color="primary" />,
        },
        {
            count: data?.cameraSummaryDashboardAdmin.activatedCamerasCount,
            text: <FormattedMessage id="reviermanager.page.devices.summary.camera" defaultMessage="Aktivierte Kameras" />,
            icon: <CameraActive fontSize="large" color="primary" />,
        },
        {
            count: data?.cameraSummaryDashboardAdmin.simsPerUserCount,
            text: <FormattedMessage id="reviermanager.page.dashboard.summary.simsPerUser" defaultMessage="SIM-Karten pro Kunde" />,
            icon: <SimPerUser fontSize="large" color="primary" />,
        },
    ];

    if (error) {
        return <ErrorComponent />;
    }

    return (
        <Summary
            items={summaryItems}
            title={intl.formatMessage({ id: "reviermanager.page.dashboard.summary.sims", defaultMessage: "Sim-Karten" })}
            variant="dashboard"
        />
    );
};

export default SimCardsSummary;
